import { useDispatch, useSelector } from "react-redux"
import { getTranslated } from "../../../utils/CommonUtils"
import { ADD, FUNCTION } from "../../../utils/Constants"
import UMCButton from "../../common/UMCButton"
import { setPkActionMode, setProgKeysInstruction } from "../../../store/reducers/ProgKeysReducer"

const ProgKeysFooter = (props) => {
    const dict = useSelector(state => state.common.dict)
    const pkActionMode = useSelector(state => state.progkeys.pkActionMode)
    const dispatch = useDispatch()

    const handleSave = () => {
        props.handleSave && props.handleSave()
    }

    const getFooter = () => {
        if (pkActionMode === FUNCTION) {
            return (
                <UMCButton
                    label={"LABEL_BACK"}
                    onClick={() => {
                        dispatch(setProgKeysInstruction(getTranslated(dict, "MSG_ADD_PROGKEYS")))
                        dispatch(setPkActionMode(ADD))
                    }}
                />
            )
        } else {
            return (
                <>
                    <UMCButton
                        label={props.cancelText || "LABEL_CANCEL"}
                        onClick={() => props.handleCancel()}
                    />
                    <UMCButton
                        className={props.okDisabled ? "pk-btn-disable" : ""}
                        disabled={props.okDisabled}
                        label={props.oKText || "LABEL_SAVE"}
                        onClick={handleSave}
                        type="primary"
                    />
                </>
            )
        }
    }

    return <div className="sl-footer">{getFooter()}</div>
}

export default ProgKeysFooter